import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    console.error(error);
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    const message = error?.message ?? error;
    if (chunkFailedMessage.test(message)) {
      if (confirm('New version detected. Do you want to reload the page?')) {
        window.location.href = window.location.origin;
      }
    }
  }
}
